<template>
  <BaseModal
    :modalProps="{ size: 'lg', 'no-close-on-backdrop': true }"
    title="Additional Information"
    data-testid="AdditionalInformationModalModal"
  >
    <template #trigger="{ onOpen }">
      <span v-if="candidate.additional_information">
        <b-link
          v-if="link"
          href="#"
          data-testid="additional-information-modal-trigger"
          @click.prevent="onOpen"
        >
          <span class="d-inline">View</span>
        </b-link>
        <b-button
          v-else
          variant="primary"
          data-testid="additional-information-modal-trigger"
          @click.prevent="onOpen"
        >
          <span class="d-inline">View</span>
        </b-button>
      </span>
      <span v-else>-</span>
    </template>

    <template #default="{ onClose }">
      <AdditionalInformationModalContent
        :onClose="onClose"
        :candidate="candidate"
      />
    </template>

    <template #footer="{ onClose }">
      <BaseModalControls :onOk="onClose" />
    </template>
  </BaseModal>
</template>

<script>
import BaseModal from '@/components/BaseModal/BaseModal'
import BaseModalControls from '@/components/BaseModal/BaseModalControls/BaseModalControls'
import AdditionalInformationModalContent from './AdditionalInformationModalContent/AdditionalInformationModalContent'

export default {
  name: 'AdditionalInformationModalModal',
  components: {
    BaseModal,
    BaseModalControls,
    AdditionalInformationModalContent
  },
  props: {
    candidate: {
      type: Object,
      default: () => {}
    },
    link: {
      type: Boolean,
      default: () => false
    }
  }
}
</script>
